var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEyeClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24.663,
    viewBox: "0 0 26 24.663",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5800",
    d: "M12.128 15.327L2.756 24.7a1.3 1.3 0 1 1-1.838-1.843l9.521-9.521a2.6 2.6 0 0 1 3.019-3.019L22.983.794a1.3 1.3 0 1 1 1.838 1.838l-9.371 9.373a2.6 2.6 0 0 1-3.323 3.323zm9.8-7.965C24.375 8.771 26 10.718 26 12.876c0 4.308-6.445 7.791-13 7.8a19.151 19.151 0 0 1-3.968-.416l2.418-2.418a5.2 5.2 0 0 0 6.514-6.514l3.966-3.967zm-5.406-1.945L14.137 7.8a5.2 5.2 0 0 0-6.213 6.213l-4.2 4.192C1.474 16.812 0 14.937 0 12.876c0-4.308 6.479-7.822 13-7.8a19.225 19.225 0 0 1 3.522.341z",
    transform: "translate(0 -.413)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEyeClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye-close.bc52d3e1ddf82d1ef904cb9925e9a139.svg";